<template>
    <aside class="master-table-row-options">
        <div v-if="item.deleting" class="deleting-container">
            <span>Deleting</span>
            <loading-dots />
        </div>
        <div v-else class="master-table-row-options-container" v-cloak>
            <div class="option-container" v-for="option in options" :key="option.label" :class="option.class">
                <div class="option-image-container" @click="option.action(item)">
                    <img :src="option.iconUrl" :alt="`${ item.label } Icon`">
                </div>
                <span>{{ option.label }}</span>
            </div>
        </div>
    </aside>
</template>

<script>
const LoadingDots = () => import('@/components/svg/loading-dots.vue');
export default {
    name: 'MasterTableRowOptions',

    components: {
        'loading-dots': LoadingDots
    },

    props: {
        item: {
            type: Object
        },

        options: {
            type: Array
        }
    }
}
</script>

<style>
.master-table-row-options .master-table-row-options-container {
    background: #382153;
    color: #ffffff;
    height: 52px;
    border-radius: 26px 0 0 26px;
    position: absolute;
    right: 0;
    padding: 2px;
    display: flex;
    align-items: center;
    opacity: 1;
    transition: all 250ms ease-out;
}

.master-table-row:hover .master-table-row-options-container {
    opacity: 1;
}

.master-table-row-options .master-table-row-options-container .option-container {
    position: relative;
    width: 34px;
    margin: 0 5px 0 5px;
}

.master-table-row-options .master-table-row-options-container .option-container span {
    display: none;
    padding: 12px 15px;
    border-radius: 9px;
    background-color: #382153;
    box-shadow: 0px 3px 6px #00000029;
    font-size: 14px;
    text-align: center;
    min-width: 90px;
}

.master-table-row-options .master-table-row-options-container .option-image-container {
    height: 34px;
    width: 34px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    cursor: pointer;
    transition: all .2s ease-in-out;
}

.master-table-row-options .master-table-row-options-container .option-image-container:hover + span {
    display: inline-block;   
    position: absolute;
    right: 50%;
    margin-right: -45px;
}

.master-table-row-options .master-table-row-options-container .option-image-container:hover {
    transform: scale(1.2); 
}

.master-table-row-options .master-table-row-options-container .email-option .option-image-container  {
    background: linear-gradient(0deg, #1FA2FF 0%, #ABFECE 100%);
}

.master-table-row-options .master-table-row-options-container .activity-option .option-image-container,
.master-table-row-options .master-table-row-options-container .approve-option .option-image-container,
.master-table-row-options .master-table-row-options-container .remove-under-review-option .option-image-container,
.master-table-row-options .master-table-row-options-container .create-campaign-option .option-image-container,
.master-table-row-options .master-table-row-options-container .enable-option .option-image-container {
    background: linear-gradient(0deg, #28DA35 0%, #13EEB3 100%);
}

.master-table-row-options .master-table-row-options-container .task-option .option-image-container {
    background: linear-gradient(0deg, #F30070 0%, #EB7E0A 100%);
}

.master-table-row-options .master-table-row-options-container .edit-option .option-image-container, 
.master-table-row-options .master-table-row-options-container .overview-option .option-image-container,
.master-table-row-options .master-table-row-options-container .merge-option .option-image-container,
.master-table-row-options .master-table-row-options-container .export-option .option-image-container,
.master-table-row-options .master-table-row-options-container .add-option .option-image-container,
.master-table-row-options .master-table-row-options-container .post-option .option-image-container,
.master-table-row-options .master-table-row-options-container .duplicate-option .option-image-container,
.master-table-row-options .master-table-row-options-container .create-option .option-image-container,
.master-table-row-options .master-table-row-options-container .manage-option .option-image-container,
.master-table-row-options .master-table-row-options-container .invite-link-option .option-image-container,
.master-table-row-options .master-table-row-options-container .download-option .option-image-container,
.master-table-row-options .master-table-row-options-container .manage-option .option-image-container,
.master-table-row-options .master-table-row-options-container .calendar-option .option-image-container { 
    background: #18AEFF;
}    

.master-table-row-options .master-table-row-options-container .delete-option .option-image-container,
.master-table-row-options .master-table-row-options-container .unsubscribe-option .option-image-container,
.master-table-row-options .master-table-row-options-container .cancel-option .option-image-container,
.master-table-row-options .master-table-row-options-container .disable-option .option-image-container,
.master-table-row-options .master-table-row-options-container .remove-option .option-image-container,
.master-table-row-options .master-table-row-options-container .deny-option .option-image-container,
.master-table-row-options .master-table-row-options-container .place-under-review-option .option-image-container {
    background-color: #F30070;
}

.master-table-row-options .master-table-row-options-container .option-container:last-child span {
    right: 0;
    margin-right: 0;
}

 .master-table-row-options .master-table-row-options-container .option-image-container img {
     width: 15px;
 }

 .master-table-row-options .master-table-row-options-container .option-container.task-option .option-image-container img {
     width: 13px;
 }

.master-table-row-options .master-table-row-options-container .activity-option .option-image-container img {
     width: 17px;
 }
.master-table-row-options .deleting-container {
    background: #F30070;
    color: #ffffff;
    height: 52px;
    border-radius: 26px 0 0 26px;
    position: absolute;
    right: 0;
    padding: 13px 20px 13px 30px;
    display: flex;
    transition: all 250ms ease-out;
    z-index: 3;
}

.master-table-row-options .deleting-container .loading-dots {
    margin-left: 20px;
}
</style>